module.exports = __webpack_public_path__ + "static/media/download_black.19be5bb1.svg";